import React from 'react';
import { useSelector } from 'react-redux';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

import LockIcon from '@mui/icons-material/LockRounded';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => {
  const { spacing } = theme;
  return {
    root: {
      alignItems: 'center',
      borderLeft: '1px solid rgba(151,151,151,0.4)',
      display: 'flex',
    },
    lock: {
      color: theme.palette.text.primary,
      marginLeft: spacing(1),
    },
    text: {
      color: theme.palette.text.secondary,
      marginLeft: spacing(1) - 2,
    },
  };
});

const TertiaryTrust = () => {
  const { classes } = useStyles();
  const showTertiaryTrust = !useSelector(featureFlagsSelectors.getFeatureFlags).get('addfiSecPrivTrust');

  if (!showTertiaryTrust) {
    return null;
  }

  return (
    <div className={classes.root}>
      <LockIcon className={classes.lock} />
      <Typography className={classes.text} color='secondary' variant='paragraphRegular'>
        Secured, encrypted connections.
      </Typography>
      <br />
    </div>
  );
};

export default TertiaryTrust;
